
<div class="suggested-points__search-engine">
  <input
    #inputSearch
    [(ngModel)]="value"
    class="search-engine__input ci-paragraph-p1-regular"
    type="text"
    [attr.placeholder]="('Buscar' | translate) + '...'"
  />

  @if(value && value.length > 0) {
    <ci-icon-button
      matSuffix
      mat-icon-button
      class="search-engine__clear-button"
      type="standard" 
      name="close"
      aria-label="Clear"
      (click)="handleClearInput()"
    ></ci-icon-button>
      <!--<lucide-icon
        name="circle-x"
        (click)="handleClearInput()"
      />-->
  } @else {
    
    <ci-icon 
      class="search-engine__icon"
      type="svg" 
      name="search" 
      scale="1x"
    ></ci-icon>
    <!--<lucide-icon
      name="search"
      class="search-engine__icon"
      aria-hidden="true"
    />-->
  }

  @if(isDebouncing) {
    <ci-icon 
      class="search-engine__debounce-icon"
      type="svg" 
      name="loader-debounce"
      scale="1x"
    ></ci-icon>
  }
</div>
